<template>
  <button 
    @click="applyFiltersToSearch" 
    @keypress="applyFiltersToSearch"
    class="button button-primary filters__apply-button" 
    :class="{ 'is-tab2': isTab2}"
    tabindex="0">
    {{ applyFiltersText }}
  </button>
</template>

<script>
import Vue from "vue";

export default Vue.component("FiltersApplyButton", {
  props: {
    APICall: Function,
    applyFiltersText: String,
    isTab2: Boolean,
    updateShowOptions: Function,
  },
  methods: {
    applyFiltersToSearch: function () {
      this.$router
        .replace({
          name: "search",
          query: this.$store.state.queryStringObjectToAPI,
        })
        .catch(() => {});

      const pageNumAndQs = `Page=1&${this.$store.state.queryStringToAPI}`;
      if(this.$store.state.queryStringToAPI != null && this.$store.state.queryStringToAPI == "") {
        this.$store.dispatch('UpdateShowResultsCountText', false);
        this.$store.dispatch('UpdateShowNoResultsText', true);
      }
      
      if(this.$store.state.queryStringToAPI != null && this.$store.state.queryStringToAPI != ''){
        this.$store.dispatch('UpdateShowResultsCountText', true);
        this.$store.dispatch('UpdateShowNoResultsText', true);
      }
      this.$store.state.loading = true;
      this.APICall(pageNumAndQs);
      this.updateShowOptions(false);
    },
  },
});
</script>